import { Amazon, Blockquote, Youtube, Twitter, Instagram } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Amazon,
  Blockquote,
  Youtube,
  Twitter,
  Instagram,
  React
};